import React from 'react'
import PageBody from 'Common/Custom/PageBody'
import AddItemBtn from 'Common/Custom/AddItemBtn'
import { HeadingOne } from 'Common/Custom/HeadingOne'

import PoolPackageListTable from './Components/PoolPackageListTable'

const PoolPackageList = () => {
    return (
        <PageBody    
            card={true}
            headerchildren={
                <>
                    <HeadingOne>Pool Package List</HeadingOne>
                    <AddItemBtn url="add-pool-package" title="Create Pool Package" />
                </>
            }>

            {/* Table section */}
            <div className="col-12">
                <PoolPackageListTable />
            </div>
        </PageBody>
    )
}

export default PoolPackageList;